import { Phone, Car } from "lucide-react";
import { trackConversion } from "@/lib/gtag";

/**
 * Call-first CTA shown directly under the hero headline on mobile only.
 * Desktop keeps the existing inline button row.
 */
export function MobileHeroCta({ quoteLabel = "Get instant quote" }: { quoteLabel?: string }) {
  return (
    <div className="mt-6 space-y-2 lg:hidden">
      <a
        href="tel:0493100265"
        onClick={() => trackConversion("phoneCall")}
        className="flex min-h-[52px] w-full items-center justify-center gap-2 rounded-md bg-primary px-5 text-base font-bold tracking-wide text-primary-foreground"
      >
        <Phone className="h-5 w-5" />
        CALL 0493 100 265 — 24/7
      </a>
      <a
        href="#book"
        className="flex min-h-[48px] w-full items-center justify-center gap-2 rounded-md border border-primary px-5 text-sm font-bold tracking-wide text-primary"
      >
        <Car className="h-4 w-4" />
        {quoteLabel.toUpperCase()}
      </a>
    </div>
  );
}